import type { ReactNode } from "react";
import { StyledStateMessage } from "./StateMessage.styled";

type StateMessageProps = {
  variant?: "default" | "error";
  children: ReactNode;
};

const StateMessage = ({ variant = "default", children }: StateMessageProps) => (
  <StyledStateMessage className={variant === "error" ? "error" : undefined}>
    {children}
  </StyledStateMessage>
);

export default StateMessage;
